<template>
  <div v-if="loading">
    <Loading />
  </div>
  <div v-else class="content w-full">
    <TopNavbar />
    <div class="page-content">
      <template v-if="developerData">
            <DeveloperInfo @get-data="fetchDeveloper" :developerData="developerData"/>
          </template>
          <template v-else>
            <NotFoundContent
              :message="$t('Developer.notFound')"
            />
          </template>
    </div>
  </div>

  <NotificationComponent
    v-if="notification.show"
    :key="notification.key"
    :type="notification.type"
    :title="notification.title"
    :message="notification.message"
    @closed="!notification.show"
  />
</template>

<script>
import TopNavbar from "@/components/user/layout/TopNavbar.vue";
import DeveloperOverviewComponent from "@/components/user/viewComponent/developer/DeveloperOverviewComponent.vue";
import DynamicVisibility from "@/components/custom/visibility/DynamicVisibility.vue";
import DeveloperInfo from "./DeveloperInfo.vue";
import Loading from "@/components/user/layout/LoadingComponent.vue";
import NotificationComponent from "@/components/custom/notifications/NotificationComponent.vue";
import NotFoundContent from "@/components/user/common/NotFoundContent.vue";
import { getDeveloperByStoreId, processDeveloperByStoreId } from "@/api/developer.api";

export default {
  name: "DeveloprViewComponent",
  components: {
    TopNavbar,
    DeveloperOverviewComponent,
    DynamicVisibility,
    DeveloperInfo,
    Loading,
    NotificationComponent,
    NotFoundContent,
  },
  data() {
    return {
      storeId: this.$route.params.storeId,
      loading: false,
      developerData: null,
      notification: {
        show: false,
        key: 0,
        type: "",
        title: "",
        message: "",
      },
    };
  },
  async created() {
    await this.fetchDeveloper();
  },
  methods: {
    async fetchDeveloper() {
      try {
        if (!this.storeId) return;
        this.loading = true;
        // const response = await getDeveloperByStoreId(this.storeId);
        const response = await processDeveloperByStoreId(this.storeId);
        if (response.data.status) {
          this.developerData = response.data.data;
        }
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    toggleVisibility(visible) {
      this.$refs.dynamicVisibility.toggle(visible);
    },
  },
};
</script>

<style></style>
